import rbiOrdersSearchMapping from './rbi/RbiOrdersSearchMapping';

/**
 * Returns the orderingSystem-specific values based on the key.
 * The key-value pairing can be different based on the partner
 * and their ordering system. This consolidates the partner-specific
 * orders search into one place.
 *
 * Return an empty string for keys that do not exist to keep to the
 * cadence that the rest of the fields will display nothing.
 *
 * @param {String} orderingSystem
 * @param {Object} ordersSearch
 * @param {String} key
 * @returns {String}
 */
const getValue = (orderingSystem, ordersSearch, key) => {
  switch (orderingSystem) {
    case 'custom_rbi':
      return rbiOrdersSearchMapping.getValue(ordersSearch, key);
    default:
      return '';
  }
};

export default {
  getValue,
};
